import AdminApi from '../../services/api'
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";
import { formatChatDate } from "./ChatDateUtils";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            conversationId: null,
            userId: null,
            userName: null,
            messages: [],
            newMessage: '',
            isLoading: false,
            isLoadingMoreMessages: false,
            isSending: false,
            errorMessage: '',
            page: 0,
            limit: 30,
            totalMessagesCount: 0,
            hasMoreMessages: false
        }
    },
    methods: {
        loadMessages: loadMessages,
        loadOlderMessages: loadOlderMessages,
        onMessagesScroll: onMessagesScroll,
        sendMessage: sendMessage,
        loadConversationAfterStart: loadConversationAfterStart,
        goBack: goBack,
        isMyMessage: isMyMessage,
        getSenderName: getSenderName,
        getTitle: getTitle,
        formatDate: formatDate,
        scrollMessagesToBottom: scrollMessagesToBottom
    },
    beforeMount() {
        if (!['ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_TRAINER'].includes(session.getRole())) {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.conversationId = this.$route.query.id;
        this.userId = this.$route.query.userId;
        this.userName = this.$route.query.userName;
        if (this.conversationId == null && this.userId == null) {
            this.errorMessage = LocService.t('label_conversation_not_available');
            return;
        }
        if (this.conversationId != null) {
            this.loadMessages();
        }
    }
}

function loadMessages() {
    this.isLoading = true;
    this.errorMessage = '';
    this.page = 0;
    AdminApiService.getChatMessages(this.conversationId, 0, this.limit)
        .then((response) => {
            let messages = response.data != null && response.data.results != null ? response.data.results : [];
            this.totalMessagesCount = response.data != null && response.data.totalCount != null ? response.data.totalCount : messages.length;
            this.messages = messages.slice().reverse();
            this.hasMoreMessages = this.messages.length < this.totalMessagesCount;
            return AdminApiService.markChatConversationRead(this.conversationId);
        })
        .then(() => {
            this.$topnavbar.$emit('refreshChatUnreadCount');
        })
        .catch(error => {
            this.errorMessage = getErrorMessage(error);
        })
        .finally(() => {
            this.isLoading = false;
            this.scrollMessagesToBottom();
        })
}

function loadOlderMessages() {
    if (this.conversationId == null || this.isLoading || this.isLoadingMoreMessages || !this.hasMoreMessages) return;
    let messagesPanel = this.$refs.messagesPanel;
    let previousScrollHeight = messagesPanel != null ? messagesPanel.scrollHeight : 0;
    let nextPage = this.page + 1;
    this.isLoadingMoreMessages = true;
    AdminApiService.getChatMessages(this.conversationId, nextPage, this.limit)
        .then((response) => {
            let messages = response.data != null && response.data.results != null ? response.data.results : [];
            let totalCount = response.data != null && response.data.totalCount != null ? response.data.totalCount : (this.messages.length + messages.length);
            this.totalMessagesCount = totalCount;
            this.page = nextPage;
            this.messages = messages.slice().reverse().concat(this.messages);
            this.hasMoreMessages = this.messages.length < this.totalMessagesCount && messages.length > 0;
            this.$nextTick(() => {
                let panel = this.$refs.messagesPanel;
                if (panel == null) return;
                panel.scrollTop = panel.scrollHeight - previousScrollHeight;
            });
        })
        .catch(error => {
            this.errorMessage = getErrorMessage(error);
        })
        .finally(() => {
            this.isLoadingMoreMessages = false;
        })
}

function onMessagesScroll() {
    let messagesPanel = this.$refs.messagesPanel;
    if (messagesPanel == null || messagesPanel.scrollTop > 24) return;
    this.loadOlderMessages();
}

function scrollMessagesToBottom() {
    this.$nextTick(() => {
        let messagesPanel = this.$refs.messagesPanel;
        if (messagesPanel == null) return;
        messagesPanel.scrollTop = messagesPanel.scrollHeight;
    });
}

function sendMessage() {
    if (this.newMessage.trim().length === 0 || this.isSending) return;
    this.isSending = true;
    this.errorMessage = '';
    let model = {
        message: this.newMessage.trim()
    };
    if (this.conversationId != null) {
        model.conversationId = this.conversationId;
    } else {
        model.userId = this.userId;
    }
    AdminApiService.sendChatMessage(model)
        .then(() => {
            this.newMessage = '';
            if (this.conversationId != null) {
                this.loadMessages();
            } else {
                this.loadConversationAfterStart();
            }
        })
        .catch(error => {
            this.errorMessage = getErrorMessage(error);
        })
        .finally(() => {
            this.isSending = false;
        })
}

function loadConversationAfterStart() {
    AdminApiService.getChatConversations(0, 20)
        .then((response) => {
            let conversations = response.data != null && response.data.results != null ? response.data.results : [];
            let conversation = conversations.find(item => ('' + item.userId) === ('' + this.userId) && item.targetType === getExpectedTargetType());
            if (conversation != null) {
                this.conversationId = conversation.id;
                this.userId = null;
                this.$router.replace({
                    path: '/admin-chat-conversation',
                    query: {
                        id: conversation.id
                    }
                });
                this.loadMessages();
            } else {
                this.goBack();
            }
        })
        .catch(() => {
            this.goBack();
        })
}

function goBack() {
    this.$router.push('/admin-chat');
}

function getExpectedTargetType() {
    return session.getRole() === 'ROLE_TRAINER' ? 'TRAINER' : 'ADMIN';
}

function isMyMessage(message) {
    return message.senderRole !== 'ROLE_USER';
}

function getSenderName(message) {
    let fullName = ((message.senderName || '') + ' ' + (message.senderSurname || '')).trim();
    return fullName.length > 0 ? fullName : message.senderUsername;
}

function getTitle() {
    return this.userName != null ? this.userName : LocService.t('label_messages');
}

function formatDate(value) {
    return formatChatDate(value);
}

function getErrorMessage(error) {
    if (error != null && error.data != null && error.data.localized_error_message != null) {
        return error.data.localized_error_message;
    }
    return LocService.t('label_chat_load_error');
}



// WEBPACK FOOTER //
// ./src/components/Chat/AdminChatConversation.js